function brandSectionCategoryFormDialog () {
  return {
    restrict: 'E',
    templateUrl: '/brand/dialogs/brand-section-category-form/brand-section-category-form-dialog.html?$$REVISION$$'
  }
}
export { brandSectionCategoryFormDialog }
